import { EAdventDoorsHashs } from 'shared/types/doors';

const DOOR_CODE_TO_ID_MAP: Record<string, number> = {
  [EAdventDoorsHashs.FirstDoor]: 1,
  [EAdventDoorsHashs.SecondDoor]: 2,
  [EAdventDoorsHashs.ThirdDoor]: 3,
  [EAdventDoorsHashs.FourthDoor]: 4,
  [EAdventDoorsHashs.FifthDoor]: 5,
  [EAdventDoorsHashs.SixthDoor]: 6,
  [EAdventDoorsHashs.SeventhDoor]: 7,
  [EAdventDoorsHashs.EighthDoor]: 8,
};

export const findDoorId = (doorCode: string): number => {
  return DOOR_CODE_TO_ID_MAP[doorCode] ?? 0;
};
